import { IButtonStyles } from 'office-ui-fabric-react/lib/Button';

export function getColumnFlexContainerStyle(): IButtonStyles {
    return {
        flexContainer: {
            width: '100%',
            flexDirection: 'column',
            padding: 0,
        },
    };
}
